/* eslint-disable prettier/prettier */
import moment from 'moment'
import { _object } from './interfaces'
export type PaymentType =
  | "CashOnDelivery"
  | "PrePaid"
  | "InAGivenNumberOfDays"
  | "OnADayOfTheMonth"
  | "NumberOfDaysAfterEOM"
  | "DayOfMonthAfterEOM"
  | string;

export const generateQueryParams = (args: _object) => {
  let str = ''
  let replace = ''
  for (const key in args) {
    if (typeof args[key] === 'object') {
      for (const key1 in args[key]) {
        str += `&filters[${key1}]=${args[key][key1]}`
        replace = str.slice(1)
      }
    } else {
      str += `&${key}=${args[key]}`
      replace = str.slice(1)
    }
  }
  return replace
}
export const generateQueryParams2 = (args: _object) => {
  const params: string[] = []

  for (const key in args) {
    const value = args[key]

    // Skip empty values
    if (value === '' || value === null || value === undefined) continue

    // Handle nested filters object
    if (key === 'filters' && typeof value === 'object') {
      for (const nestedKey in value) {
        if (value[nestedKey] !== '') {
          params.push(`filters[${nestedKey}]=${encodeURIComponent(value[nestedKey])}`)
        }
      }
    } else {
      params.push(`${key}=${encodeURIComponent(value)}`)
    }
  }

  return params.join('&')
}

export function getQueryParam(key: string): string | null {
  const search = window.location.search
  return new URLSearchParams(search).get(key)
}

export const dateFormat = (date: string) => {
  const formatted = moment(date).format('MMMM DD, yyyy')
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}

export const dateFormatWitTime = (date: string) => {
  const formatted = moment(date).format('MMMM DD, YYYY [at] hh:mm A')
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}

export const formatPrice = (amount: number, currency = '$') => {
  if (typeof amount !== 'number' || amount === 0) return null
  return `${currency}${amount.toFixed(2)}`
}

export function getAvatarName(fullName: string) {
  return fullName
    ?.split(' ')
    .map((word: string) => word[0].toUpperCase())
    .join('')
}

export const useRenderLogger = (name: string) => {
  console.log(`[Render] ${name} rendered`)
}

export function generatePlaceholderLogo(options = {}) {
  const defaultParams = {
    text: 'Your Logo',
    height: 60,
    fontSize: 32,
    bgColor: 'transparent',
    textColor: '000',
    fontStyle: 'minimalistic'
  }

  const params = { ...defaultParams, ...options }

  const averageCharWidth = params.fontSize * 0.6
  const buffer = 10
  const width = Math.ceil(params?.text?.length * averageCharWidth + buffer)

  const fontFamilies: Record<string, string> = {
    minimalistic: 'Noto Sans',
    elegant: 'Playfair Display',
    creative: 'Raleway',
    professional: 'Roboto'
  }

  const fontFamily = fontFamilies[params.fontStyle] || fontFamilies['minimalistic']

  return `https://placehold.co/${width}x${params.height}/${params.bgColor}/${params.textColor}?text=${encodeURIComponent(params.text)}&fontsize=${params.fontSize}&font=${encodeURIComponent(fontFamily)}`
}

export function getStatusLabel(status: string) {
  if (status === 'processing') return 'Processing'
  if (status === 'Open') return 'Open'
  if (status === 'completed') return 'Completed'
  return '' // or return 'Unknown' if you want a fallback
}

export function generateDayWiseData(apiData: _object, startDate: string, endDate: string) {
  const result = []
  const current = new Date(startDate)
  const end = new Date(endDate)

  while (current <= end) {
    const year = current.getFullYear()
    const month = String(current.getMonth() + 1).padStart(2, '0')
    const day = String(current.getDate()).padStart(2, '0')
    const dateStr = `${year}-${month}-${day}`

    const match = apiData?.data?.find((item: _object) => item.date === dateStr)
    result.push(
      match || {
        date: dateStr,
        number_of_orders: 0,
        total_orders_amount: 0
      }
    )

    current.setDate(current.getDate() + 1)
  }

  return result
}

export function generateMonthWiseData(apiData: _object, startDate: string, endDate: string) {
  const result = []
  const current = new Date(startDate)
  const end = new Date(endDate)

  current.setDate(1)

  while (current <= end) {
    const monthStr = current.toLocaleString('default', { month: 'long', year: 'numeric' })
    const match = apiData?.data?.find((item: _object) => item.month === monthStr)
    result.push(
      match || {
        month: monthStr,
        number_of_orders: 0,
        total_orders_amount: 0
      }
    )
    current.setMonth(current.getMonth() + 1)
  }
  return result
}

export const formatPaymentType = (value: PaymentType) => {
  switch (value) {
    case 'CashOnDelivery':
      return 'Cash On Delivery'
    case 'PrePaid':
      return 'Pre Paid'
    case 'InAGivenNumberOfDays':
      return 'In Given Number Days'
    case 'OnADayOfTheMonth':
      return 'On Day Of The Month'
    case 'NumberOfDaysAfterEOM':
      return 'Number Of Days After EOM'
    case 'DayOfMonthAfterEOM':
      return 'Day Of Month After EOM'
    default:
      return value
  }
}
